var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharedDc = function SvgSharedDc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V8H15V3ZM6 6V5H9V6H6Z",
    fill: "#DA70D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H3V14H15V10Z",
    fill: "#DA70D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14V10H21V14H17Z",
    fill: "#DA70D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16H3V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H15V16ZM6 19V18H9V19H6Z",
    fill: "#DA70D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V16H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H17Z",
    fill: "#DA70D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8V3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V8H17Z",
    fill: "#DA70D6"
  })));
};
export default SvgSharedDc;